/**
 *  Copyright (c) 2026 TechDivision GmbH
 *  All rights reserved
 *
 *  This product includes proprietary software developed at TechDivision GmbH, Germany
 *  For more information see https://www.techdivision.com/
 *
 *  To obtain a valid license for using this software please contact us at
 *  license@techdivision.com
 *
 */

/* events.js
   Events listing – client-side tag filtering plus per-card "show more" for the
   description. Only one tag can be active at a time; the empty "all" tag shows
   every event. Filtering runs over the data-event-tags attribute (comma-separated,
   lowercase) on each card. */

/* the card description is clamped to three lines via CSS. we only surface a
   toggle when the text is actually clipped (scrollHeight beats clientHeight),
   otherwise the button would appear on short texts too. the click stops
   propagation so the card-wide overlay link does not navigate away. */
function initDescriptionToggles(root) {
  var toggles = Array.prototype.slice.call(root.querySelectorAll('[data-event-toggle]'));

  toggles.forEach(function (btn) {
    var desc = btn.previousElementSibling;
    if (!desc || !desc.hasAttribute('data-event-desc')) return;

    // reveal the toggle only when the clamped text overflows its three lines
    if (desc.scrollHeight - desc.clientHeight > 1) {
      btn.classList.remove('hidden');
    }

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var expanded = desc.classList.toggle('line-clamp-3') === false;
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded
        ? btn.getAttribute('data-label-less')
        : btn.getAttribute('data-label-more');
    });
  });
}

export function initEvents() {
  var roots = document.querySelectorAll('[data-events]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-event-item]'));
    var tagButtons = Array.prototype.slice.call(root.querySelectorAll('[data-event-tag-btn]'));
    var emptyMessage = root.querySelector('[data-events-empty]');

    initDescriptionToggles(root);

    function filter(tag) {
      var term = (tag || '').toLowerCase();
      var visible = 0;

      items.forEach(function (item) {
        var tags = item.getAttribute('data-event-tags') || '';
        var match = term === '' || tags.split(',').indexOf(term) !== -1;
        item.hidden = !match;
        if (match) visible++;
      });

      tagButtons.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-event-tag-btn') === term ? 'true' : 'false');
      });

      if (emptyMessage) emptyMessage.hidden = visible !== 0;
    }

    tagButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filter(btn.getAttribute('data-event-tag-btn'));
      });
    });
  });
}

// loaded as a module script by the section that needs it (see
// snippets/module-script.liquid), so the module initialises itself. module
// scripts are deferred, which means the DOM is complete at this point
initEvents();
